import React from "react";

import Stack from "@busbud/design-system-components/dist/Stack";
import { Label } from "@busbud/horizon";

import { OperatorLogo } from "@app/components/operator-logo";
import { Rating } from "@app/components/rating/rating";
import { useAppContext } from "@app/helpers/hooks";

import type { ConnectorProps } from "./operator-ratings-card-header.connect";

import { useStyles } from "./operator-ratings.styles";

export const OperatorRatingsCardHeader: React.FC<ConnectorProps> = ({
  operator_name,
  operator_logo_url,
  global_rating,
  count_total
}) => {
  const { classes } = useStyles();
  const { translator } = useAppContext();
  const count_total_text = translator.t("!results.filters.operator-ratings", {
    ratings: count_total
  });

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      className={classes.operatorRatingsCardHeader}
    >
      <OperatorLogo
        logo_url={operator_logo_url}
        operator_name={operator_name}
        size="md"
        className={classes.operatorRatingsCardHeaderLogo}
      />
      <div className="flex flex-col items-end">
        <Rating size="sm" rating={global_rating} total_reviews={count_total} />
        <Label as="span" size="xxs" className="text-color-secondary">
          {count_total_text}
        </Label>
      </div>
    </Stack>
  );
};
